import { render, staticRenderFns } from "./Reveal.vue?vue&type=template&id=1a47fab1&scoped=true&"
import script from "./Reveal.vue?vue&type=script&lang=js&"
export * from "./Reveal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a47fab1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1a47fab1', component.options)
    } else {
      api.reload('1a47fab1', component.options)
    }
    module.hot.accept("./Reveal.vue?vue&type=template&id=1a47fab1&scoped=true&", function () {
      api.rerender('1a47fab1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/errors/Reveal.vue"
export default component.exports